import "../assets/saatepea_v3.mp4";
import "../assets/saatepea_v3_poster.jpg";
import "../assets/logo-vista.svg";

import "../assets/icon-menu.svg";
import "../assets/icon-about.svg";
import "../assets/icon-vistas.svg";
import "../assets/icon-videotitle.svg";
import "../assets/icon-videochallenge.svg";
import "../assets/icon-videoline.svg";
import "../assets/icon-prize.svg";
import "../assets/icon-ending.svg";
import "../assets/icon-mail.svg";
import "../assets/icon-fb.svg";
import "../assets/icon-titleline.svg";

import "../assets/arrow-challenge.svg";
import "../assets/arrow-video.svg";

import Rellax from "rellax";
import Tabs from "./tabs";

const rellax = new Rellax(".rellax");

const allTabContainers = document.querySelectorAll("[data-tabs]");
allTabContainers.forEach((el) => {
  const tab = new Tabs(el);
  tab.init();
});

const menuButton = document.querySelectorAll(".js-trigger-menu");

menuButton.forEach((element) => {
  element.addEventListener("click", (event) => {
    document.querySelector("body").classList.toggle("is-menu-active");
  });
});

// Menu observer

const menuEl = document.querySelector(".js-menu-observer");
const menuBgEl = document.querySelector(".js-menu-bg-observer");
const sectionEls = document.querySelectorAll(".js-section-bg");

const handler = (entries) => {
  if (entries[0].isIntersecting) {
    menuEl.classList.add("enabled");
    menuBgEl.classList.add("enabled");
  } else {
    menuEl.classList.remove("enabled");
    menuBgEl.classList.remove("enabled");
  }
};
  
let observerConfig = {
  root: null,
  rootMargin: '0px',
  threshold: 0.2
};

let observer = new window.IntersectionObserver(handler, observerConfig);

sectionEls.forEach ( sec => {
  observer.observe(sec); 
}
);


// Challenge Arrow observer

const arrowChallengeEl = document.querySelector(".js-arrow-challenge");
const challengeSectionEl = document.querySelector(
  ".js-trigger-arrow-challenge"
);

const handlerArrowChallenge = (entries) => {
  if (!entries[0].isIntersecting) {
    arrowChallengeEl.classList.remove("arrow-challenge-svg");
  } else {
    arrowChallengeEl.classList.add("arrow-challenge-svg");
  }
};

const observerArrowChallenge = new window.IntersectionObserver(
  handlerArrowChallenge
);
observerArrowChallenge.observe(challengeSectionEl);

// Video Arrow observer

const arrowVideoEl = document.querySelector(".js-arrow-video");
const videoSectionEl = document.querySelector(".js-trigger-arrow-video");

const handlerArrowVideo = (entries) => {
  if (!entries[0].isIntersecting) {
    arrowVideoEl.classList.remove("arrow-video-svg");
  } else {
    arrowVideoEl.classList.add("arrow-video-svg");
  }
};

const observerArrowVideo = new window.IntersectionObserver(handlerArrowVideo);
observerArrowVideo.observe(videoSectionEl);
